"use client";

import { useContext, useState } from "react";
import { UserContext } from "@/contexts/user-context";
import { logEvent } from "@/service/logs/log";
import { ResourceContext } from "@/contexts/resource-context";
import { Switch } from "@/components/ui/switch";
import { clientPost } from "@/service/client-api/client-api";
import { Button } from "@/components/ui/button";
import { useRouter } from "@bprogress/next";
import { toast } from "sonner";

export const NewsletterSwitch = ({
  isButton,
  setHide = () => {},
}: {
  isButton?: boolean;
  setHide?: () => void;
}) => {
  const { isLoggedIn, marketing } = useContext(UserContext);
  const { newsletter } = marketing ?? {};
  const { tags } = newsletter ?? {};
  const { logView } = useContext(ResourceContext);
  const router = useRouter();
  const [subscribed, setSubscribed] = useState<boolean>(
    tags?.includes("klub-medyka"),
  );

  function switchSubscription() {
    clientPost(subscribed ? "newsletter.unsubscribe" : "newsletter.subscribe");

    logEvent("club_newsletter_save", logView, {
      subscribed: !subscribed,
    });
  }

  if (!isLoggedIn) {
    return <></>;
  }

  if (isButton) {
    return (
      <Button
        variant="outlineWhite"
        className="@512:w-fit w-full"
        onClick={() => {
          switchSubscription();
          router.refresh();
          setHide();
          toast.success("Dziękujemy za zapisanie się do newslettera!");
        }}
      >
        Zapisz się
      </Button>
    );
  }

  return (
    <Switch
      checked={subscribed}
      onCheckedChange={() => {
        switchSubscription();
        setSubscribed(!subscribed);
      }}
      className="data-[state=checked]:bg-remedium-blue-/5"
    />
  );
};
